<template>
  <modal
    :show.sync="open"
    class="modal-search"
    id="searchModal"
    :centered="true"
    :show-close="true"
    @close="_reset"
  >
    <div slot="header-title">
      {{ titleb }}
    </div>
    <div slot="default">
      <template v-if="loading">
        <div class="invoice-placeholder">
          <content-placeholders
            :rounded="true"
            :centered="true"
            :animated="true"
          >
            <content-placeholders-text :lines="3" />
            <content-placeholders-img />
            <content-placeholders-text :lines="1" class="placeholder-first" />
            <content-placeholders-text :lines="4" />
          </content-placeholders>
        </div>
      </template>

      <template v-else>
        <template v-if="!invoice.uuid">
          <payment-method
            @selected="(x) => (this.currencyId = x)"
            @service="(x) => (this.invoiceType = x)"
            @title="titleb = $event"
            ref="paymentMethod"
          ></payment-method>
        </template>

        <template v-if="isPaymentCompleted">
          <payment-completed
            @title="title = $event"
            :invoice="invoice"
          ></payment-completed>
        </template>

        <template v-if="showPaymentInfo">
          <payment-info
            :invoice="invoice"
            ref="paymentInfo"
            @activation-wallet="() => useActivationWallet()"
            @title="title = $event"
          ></payment-info
        ></template>

        <template v-if="invoice.invoice_status === 'paid'">
          <invoice-paid
            :invoice="invoice"
            @title="title = $event"
          ></invoice-paid>
        </template>
      </template>
    </div>

    <template slot="footer">
      <a class="btn btn-warning text-dark btn-block mt-2" @click="_reset">
        CLOSE
      </a>
    </template>
  </modal>
</template>

<style lang="scss">
.invoice-placeholder {
  .placeholder {
    &-first {
      margin-left: auto;
      margin-right: auto;
      width: 80% !important;
      margin-bottom: 30px;
    }
  }
  .vue-content-placeholders-text__line::before {
    background: #414141 !important;
  }
  .vue-content-placeholders-text__line {
    background: #3e3e3e !important;
  }

  .vue-content-placeholders-img::before {
    background: #3f3f3f !important;
    height: 250px !important;
    width: 250px !important;
  }
  .vue-content-placeholders-img {
    background: #3e3e3e !important;
    height: 250px !important;
    width: 250px !important;
  }
}

.close {
  &-button {
    width: 100% !important;
    display: flex;
    align-items: center;
  }
}
</style>

<script>
import { mathMixin } from "@/mixins/";
import modal from "./../Modal";
import { serverBus, database } from "@/main";
import InvoicePaid from "./InvoicePaid";
import PaymentCompleted from "./PaymentCompleted";
import PaymentMethod from "./PaymentMethod";
import PaymentInfo from "./PaymentInfo";

import "@lottiefiles/lottie-player";
import confetti from "canvas-confetti";
import { mapGetters } from "vuex";

export default {
  name: "invoice-payment",
  mixins: [mathMixin],
  data() {
    return {
      open: false,
      isPaymentCompleted: false,
      currencyId: null,
      invoiceType: null,
      selectedPlan: {},
      invoice: {
        currency: {
          name: "BTC",
        },
        plan: {
          price: "0",
          name: "-",
        },
      },
      title: "",
      titleb: "",
    };
  },
  components: {
    modal,
    InvoicePaid,
    PaymentCompleted,
    PaymentMethod,
    PaymentInfo,
  },
  created() {
    serverBus.$on("invoicePaymentModal", (data) => {
      this.selectedPlan = data;
      this.open = true;
      this.titleb = "1. Which service would you like to invest in?";
    });
  },
  computed: {
    ...mapGetters("invoice", {
      loading: "isLoading",
    }),
    showPaymentInfo() {
      return this.invoice.uuid && !this.isPaymentCompleted ? true : false;
    },
  },
  watch: {
    invoice(newVal) {
      let fetch = database().ref(`invoices/${this.invoice.uuid}`);

      fetch.on("value", (snapshot) => {
        if (snapshot.val() && snapshot.val()["status"] === "paid") {
          this.isPaymentCompleted = true;
          this.displayConfetti();
          this.$store.dispatch("getUser");
          this.titleb = "4. Thanks for your payment!";
        }
      });

      if (newVal.uuid) {
        this.titleb = "3. Select Payment Method";
      }
    },
    currencyId(newVal) {
      if (newVal !== null) this.createInvoice();
    },
  },
  beforeDestroy() {
    serverBus.$off("invoicePaymentModal");
  },
  methods: {
    useActivationWallet() {
      this.$store.commit("invoice/setLoading", true);
      this.$http({
        url: `/api/v1/client/discounts/invoices/${this.invoice.id}`,
        method: "PUT",
        headers: {
          "content-type": "application/json",
          Authorization: this.$store.getters.authToken,
        },
        data: {},
      })
        .then((response) => {
          this.$store.commit("invoice/setLoading", false);
          this.invoice = response.data;
          this.$toasted.show("Credit Applied!", {
            position: "top-right",
            duration: 5000,
            type: "success",
            closeOnSwipe: true,
          });
        })
        .catch((error) => {
          this.$store.commit("invoice/setLoading", false);
          error.response.data &&
            error.response.data.map((m) => {
              this.$toasted.show(m, {
                position: "top-right",
                duration: 5000,
                type: "error",
                closeOnSwipe: true,
              });
            });
        });
    },
    async createInvoice() {
      this.$store.commit("invoice/setLoading", true);

      try {
        let response = await this.$http({
          url: "/api/v1/client/invoices",
          method: "post",
          headers: {
            "content-type": "application/json",
            Authorization: this.$store.getters.authToken,
          },
          data: {
            currency_id: this.currencyId,
            plan_id: this.selectedPlan.code,
            is_upgrade: this.selectedPlan.is_upgrade,
            invoice_type: this.invoiceType,
          },
        });

        this.$store.commit("invoice/setLoading", false);
        this.invoice = response.data;

        setTimeout(() => {
          this.$refs.paymentInfo.setTimer(`ten-countdown`, 15, 0);
        }, 1000);
      } catch (error) {
        this.$store.commit("invoice/setLoading", false);
        this._reset();

        error.response &&
          error.response.data &&
          error.response.data.map((m) => {
            this.$toasted.show(m, {
              position: "top-right",
              duration: 5000,
              type: "error",
              closeOnSwipe: true,
            });
          });
      }
    },
    _reset() {
      this.$refs.paymentInfo && this.$refs.paymentInfo.reset();
      this.$refs.paymentMethod && this.$refs.paymentMethod.reset();
      this.open = false;
      this.isPaymentCompleted = false;
      this.currencyId = null;
      this.selectedPlan = {};
      this.titleb = "";
      this.invoiceType = null;
      this.invoice = {
        currency: {
          name: "BTC",
        },
        plan: {
          price: "0",
          name: "-",
        },
      };
    },
    displayConfetti() {
      let duration = 15 * 500;
      let animationEnd = Date.now() + duration;
      let defaults = {
        startVelocity: 30,
        spread: 360,
        ticks: 60,
        zIndex: 1000000,
      };

      function randomInRange(min, max) {
        return Math.random() * (max - min) + min;
      }

      let interval = setInterval(function () {
        let timeLeft = animationEnd - Date.now();

        if (timeLeft <= 0) {
          return clearInterval(interval);
        }

        let particleCount = 50 * (timeLeft / duration);
        // since particles fall down, start a bit higher than random
        confetti(
          Object.assign({}, defaults, {
            particleCount,
            origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
          })
        );
        confetti(
          Object.assign({}, defaults, {
            particleCount,
            origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
          })
        );
      }, 250);
    },
  },
};
</script>
